/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.landscape\":[\"Aurinko ja vuoret\"]}");